<h4 mat-dialog-title>Pré-visualizar PDF do Formulário</h4>

<div mat-dialog-content>
    <object [safeSourceContent]="data" class="pdf" type="application/pdf" title="PDF"></object>
</div>

<div align="end" mat-dialog-actions>
    <button class="btn btn-outline-secondary" (click)="close()">
        <span>Fechar</span>
    </button>
</div>
